import { useTranslation } from "lib/i18n/use-translation";

import { Button } from "./button";
import css from "./error.module.scss";

interface ErrorProps {
  title?: string;
  message?: string;
  buttonText?: string;
  onReset?: () => void;
}

export function Error({ title, message, buttonText, onReset }: ErrorProps) {
  const { t } = useTranslation();

  const resolvedTitle = title ?? t("Ошибка загрузки книги.");
  const resolvedMessage =
    message ?? t("Перезагрузите страницу или попробуйте позже.");
  const resolvedButtonText = buttonText ?? t("Попробовать снова");

  function handleRetry() {
    if (onReset) {
      onReset();
    } else {
      window.location.reload();
    }
  }

  return (
    <div className={css.root}>
      <p className={css.message}>
        {resolvedTitle}
        <span className={css.messageContent}>{resolvedMessage}</span>
      </p>
      <Button onClick={handleRetry}>{resolvedButtonText}</Button>
    </div>
  );
}
